import React, { useState } from 'react'

import { Button } from 'devextreme-react/button'

import { IxConfirmPopup } from 'components'


export type IIxInfoBtnProps = {
    btnOptions: any,
    title: string,
    description: string,
    name?: string
    confirmPopupVisible?: any
}


export const IxInfoBtn = ({ btnOptions, title, description, name }: IIxInfoBtnProps) => {
    const [popupVisible, setPopupVisible] = useState(false)
    const hidePopup = () => setPopupVisible(false)
    const showPopup = () => setPopupVisible(true)

    return (
        <>
            <Button {...btnOptions} text={name} onClick={showPopup} />
            <IxConfirmPopup
                popupVisible={popupVisible}
                onHiding={hidePopup}

                title={title}
                description={description}
            />
        </>
    )
}
